import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/models/dom';

// tinymce sets the visibility as hidden if not imported
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';

// plugins: add more if needed
import 'tinymce/plugins/link';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/image';
import 'tinymce/plugins/table';

const EmailEditorTinyMce = ({emailData, setEmailBody}) => {
  const editorRef = useRef(null);
  
  return (
    <>
      <Editor
        onInit={(evt, editor) => { editorRef.current = editor }}
        onEditorChange={(html, _editor) => setEmailBody(html)}
        initialValue={emailData.body}
        init={{
          skin: false,
          content_css: false,
          height: 550,
          menubar: false,
          plugins: 'table link image wordcount',
          toolbar: 'undo redo | link image |' +
          'blocks | bold italic forecolor backcolor | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | table ' +
          'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
        }}
      />
    </>
  );
}

export default EmailEditorTinyMce;